import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import {
    createRequestCacheKey,
    fetchWithCache,
    invalidateRequestCache,
} from '../helpers/requestCache';
import { extractQuestionMediaUrls, preloadMediaUrls } from '../helpers/mediaPreloader';

const QUESTION_TTL_MS = 45 * 1000;
const COIN_IMAGE_TTL_MS = 30 * 60 * 1000;

const questionCacheKey = (studentId, gameId, questionId, gameLineId, direction) =>
    createRequestCacheKey('game', 'question', studentId, gameId, questionId, gameLineId, direction);
const coinImageCacheKey = () => createRequestCacheKey('game', 'coin-image');

export const questionService = {
    fetchQuestion,
    fetchCoinImage,
    submitAnswer,
    captureCoin
};

function fetchQuestion(studentid, gameid, questionid, gamelineid, direction) {
    return fetchWithCache({
        key: questionCacheKey(studentid, gameid, questionid, gamelineid, direction),
        ttlMs: QUESTION_TTL_MS,
        persistToSession: false,
        loader: () => apiClient.get(`${api.games.fetchQuestion}/${studentid}/${gameid}/${questionid}/${gamelineid}/${direction}`)
            .then(handleResponse)
            .then(data => {
                const question = data?.data ?? data ?? {};
                preloadMediaUrls(extractQuestionMediaUrls(question), { fetchpriority: 'high' });
                return data;
            }),
    })
        .catch(error => handleError(error.response));
}

function fetchCoinImage() {
    return fetchWithCache({
        key: coinImageCacheKey(),
        ttlMs: COIN_IMAGE_TTL_MS,
        loader: () => apiClient.get(api.games.fetchCoinImage)
            .then(handleResponse)
            .then(data => {
                const coinImage = data?.data ?? data ?? {};
                preloadMediaUrls(coinImage?.MediaURL);
                return data;
            }),
    })
        .catch(error => handleError(error.response));
}

function submitAnswer(ansData) {
    return apiClient.put(api.games.submitAns, ansData)
        .then(handleResponse)
        .then(data => {
            invalidateRequestCache([
                createRequestCacheKey('game', 'question'),
                createRequestCacheKey('profile', 'mypoints'),
            ]);
            return data;
        })
        .catch(error => handleError(error.response));
}

function captureCoin(coinData) {
    return apiClient.post(api.games.captureCoin, coinData)
        .then(handleResponse)
        .then(data => {
            invalidateRequestCache([
                createRequestCacheKey('game', 'question'),
                createRequestCacheKey('profile', 'mypoints'),
            ]);
            return data;
        })
        .catch(error => handleError(error.response));
}
